/**
 * Meal Mems Cart Integration
 *
 * This script intercepts add-to-cart actions on restaurant products
 * and routes them through the connected Fine Art Poster product.
 *
 * How it works:
 * 1. Detects restaurant products via mealmems metafields
 * 2. On "Add to Cart", swaps in the Fine Art Poster variant
 * 3. Includes line item properties for Gelato and cart display
 */

(function() {
  'use strict';

  // Next.js app base URL for API calls
  var MEALMEMS_API_BASE_URL = 'https://meal-mems-prod.vercel.app';

  // Poster variant IDs (connected to Gelato - original fine-art-poster product)
  var FINE_ART_POSTER_VARIANTS = {
    'vertical_5x7': 46732864192666,
    'horizontal_5x7': 46732864258202,
    'vertical_8x10': 46732864225434,
    'horizontal_8x10': 46732864290970
  };

  // Framed poster variant IDs (connected to Gelato)
  // Key format: orientation_size_framecolor
  var FRAMED_POSTER_VARIANTS = {
    // 5x7 Horizontal
    'horizontal_5x7_black': 47464637333658,
    'horizontal_5x7_white': 47464637366426,
    'horizontal_5x7_wood': 47464637399194,
    // 5x7 Vertical
    'vertical_5x7_black': 47464637431962,
    'vertical_5x7_white': 47464637464730,
    'vertical_5x7_wood': 47464637497498,
    // 8x10 Horizontal
    'horizontal_8x10_black': 47464637530266,
    'horizontal_8x10_white': 47464637563034,
    'horizontal_8x10_wood': 47464637595802,
    // 8x10 Vertical
    'vertical_8x10_black': 47464637628570,
    'vertical_8x10_white': 47464637661338,
    'vertical_8x10_wood': 47464637694106
  };

  // Check if we're on a restaurant product page
  var productData = window.mealmemesProductData;

  if (!productData || !productData.isRestaurantProduct) {
    return;
  }

  console.log('[MealMems] Restaurant product detected:', productData.restaurantName);
  console.log('[MealMems] Product data:', {
    hasFormatOption: productData.hasFormatOption,
    hasDigitalVariant: productData.hasDigitalVariant,
    digitalVariantId: productData.digitalVariantId,
    variantCount: productData.variants ? productData.variants.length : 0
  });

  /**
   * Get the correct print file URL based on orientation
   * Falls back to vertical URL if horizontal is not available
   */
  function getPrintFileUrl(orientation) {
    var isHorizontal = orientation.toLowerCase() === 'horizontal';
    if (isHorizontal && productData.printFileUrlHorizontal) {
      return productData.printFileUrlHorizontal;
    }
    return productData.printFileUrl;
  }

  /**
   * Get the correct display image URL based on orientation
   * Falls back to vertical URL if horizontal is not available
   */
  function getDisplayImageUrl(orientation) {
    var isHorizontal = orientation.toLowerCase() === 'horizontal';
    if (isHorizontal && productData.displayImageUrlHorizontal) {
      return productData.displayImageUrlHorizontal;
    }
    return productData.displayImageUrl;
  }

  function getFineArtPosterVariantId(size, orientation) {
    var normalizedOrientation = orientation.toLowerCase();
    var normalizedSize = size.replace(/[×"'″\s]/g, '').replace(/cm.*$/i, '');

    var sizeKey;
    if (normalizedSize.indexOf('5') !== -1 && normalizedSize.indexOf('7') !== -1) {
      sizeKey = '5x7';
    } else if (normalizedSize.indexOf('8') !== -1 && normalizedSize.indexOf('10') !== -1) {
      sizeKey = '8x10';
    } else {
      console.warn('[MealMems] Unknown size:', size, '- defaulting to 5x7');
      sizeKey = '5x7';
    }

    var key = normalizedOrientation + '_' + sizeKey;
    var variantId = FINE_ART_POSTER_VARIANTS[key];

    if (!variantId) {
      console.error('[MealMems] No variant found for:', key);
      return FINE_ART_POSTER_VARIANTS['vertical_5x7'];
    }

    return variantId;
  }

  function getFramedPosterVariantId(size, orientation, frameColor) {
    var normalizedOrientation = orientation.toLowerCase();
    var normalizedSize = size.replace(/[×"'″\s]/g, '').replace(/cm.*$/i, '');
    var normalizedFrame = frameColor.toLowerCase().replace(/\s+frame$/i, '');

    var sizeKey;
    if (normalizedSize.indexOf('5') !== -1 && normalizedSize.indexOf('7') !== -1) {
      sizeKey = '5x7';
    } else if (normalizedSize.indexOf('8') !== -1 && normalizedSize.indexOf('10') !== -1) {
      sizeKey = '8x10';
    } else {
      console.warn('[MealMems] Unknown framed size:', size, '- defaulting to 5x7');
      sizeKey = '5x7';
    }

    var key = normalizedOrientation + '_' + sizeKey + '_' + normalizedFrame;
    var variantId = FRAMED_POSTER_VARIANTS[key];

    if (!variantId) {
      console.error('[MealMems] No framed variant found for:', key);
      return FRAMED_POSTER_VARIANTS['vertical_5x7_black'];
    }

    console.log('[MealMems] Framed variant key:', key, '-> ID:', variantId);
    return variantId;
  }

  /**
   * Check if this is a framed product page
   */
  function isFramedProduct() {
    return productData && productData.isFramedProduct === true;
  }

  function getSelectedOptions() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return { format: 'Print', size: '5x7', orientation: 'Vertical', frameColor: 'Black' };

    var format = 'Print';
    var size = '5x7';
    var orientation = 'Vertical';
    var frameColor = 'Black';

    // Method 1: Check the hidden variant ID input and match to our variant data
    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput && variantInput.value && productData.variants) {
      var selectedVariantId = parseInt(variantInput.value, 10);
      for (var i = 0; i < productData.variants.length; i++) {
        var v = productData.variants[i];
        if (v.id === selectedVariantId) {
          // Check if this is a framed product (option structure: Size, Orientation, Frame)
          if (isFramedProduct()) {
            if (v.option1) size = v.option1;
            if (v.option2) orientation = v.option2;
            if (v.option3) frameColor = v.option3;
            console.log('[MealMems] Found framed variant by ID:', selectedVariantId, 'Size:', size, 'Orientation:', orientation, 'Frame:', frameColor);
            return { format: 'Framed', size: size, orientation: orientation, frameColor: frameColor };
          }
          // New structure: option1=Format, option2=Size, option3=Orientation
          // Legacy structure: option1=Size, option2=Orientation
          else if (productData.hasFormatOption) {
            if (v.option1) format = v.option1;
            if (v.option2) size = v.option2;
            if (v.option3) orientation = v.option3;
          } else {
            // Legacy structure
            if (v.option1) size = v.option1;
            if (v.option2) orientation = v.option2;
          }
          console.log('[MealMems] Found variant by ID:', selectedVariantId, 'Format:', format, 'Size:', size, 'Orientation:', orientation);
          return { format: format, size: size, orientation: orientation, frameColor: frameColor };
        }
      }
    }

    // Method 2: Try select elements (legacy themes)
    var formatSelect = form.querySelector('[data-option-name="Format"], [name*="Format"], select[id*="format"]');
    var sizeSelect = form.querySelector('[data-option-name="Size"], [name*="Size"], select[id*="size"]');
    var orientationSelect = form.querySelector('[data-option-name="Orientation"], [name*="Orientation"], select[id*="orientation"]');
    var frameSelect = form.querySelector('[data-option-name="Frame"], [name*="Frame"], select[id*="frame"]');

    if (formatSelect) {
      format = formatSelect.value;
    }
    if (sizeSelect) {
      size = sizeSelect.value;
    }
    if (orientationSelect) {
      orientation = orientationSelect.value;
    }
    if (frameSelect) {
      frameColor = frameSelect.value;
    }

    // Method 3: Check variant select dropdown text
    var variantSelect = form.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.selectedOptions && variantSelect.selectedOptions[0]) {
      var selectedText = variantSelect.selectedOptions[0].text || '';
      if (selectedText.toLowerCase().indexOf('digital') !== -1) format = 'Digital Download';
      if (selectedText.indexOf('5x7') !== -1 || selectedText.indexOf('5×7') !== -1) size = '5x7';
      if (selectedText.indexOf('8x10') !== -1 || selectedText.indexOf('8×10') !== -1) size = '8x10';
      if (selectedText.toLowerCase().indexOf('horizontal') !== -1) orientation = 'Horizontal';
      if (selectedText.toLowerCase().indexOf('vertical') !== -1) orientation = 'Vertical';
      // Frame color detection
      if (selectedText.toLowerCase().indexOf('black') !== -1) frameColor = 'Black';
      if (selectedText.toLowerCase().indexOf('white') !== -1) frameColor = 'White';
      if (selectedText.toLowerCase().indexOf('wood') !== -1) frameColor = 'Wood';
    }

    // If this is a framed product, set format to Framed
    if (isFramedProduct()) {
      format = 'Framed';
    }

    console.log('[MealMems] Detected options - Format:', format, 'Size:', size, 'Orientation:', orientation, 'Frame:', frameColor);
    return { format: format, size: size, orientation: orientation, frameColor: frameColor };
  }

  /**
   * Check if the current selection is a digital download
   * Uses multiple methods for robust detection
   */
  function isDigitalSelection() {
    // Method 1: Check the hidden variant input and look up in our variant data
    var variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value && productData.variants) {
      var selectedVariantId = parseInt(variantInput.value, 10);

      for (var i = 0; i < productData.variants.length; i++) {
        var v = productData.variants[i];
        if (v.id === selectedVariantId) {
          // Check if any option contains "digital" (case-insensitive)
          var isDigital = (v.option1 && v.option1.toLowerCase().indexOf('digital') !== -1) ||
                          (v.option2 && v.option2.toLowerCase().indexOf('digital') !== -1) ||
                          (v.option3 && v.option3.toLowerCase().indexOf('digital') !== -1) ||
                          (v.title && v.title.toLowerCase().indexOf('digital') !== -1);

          if (isDigital) {
            console.log('[MealMems] Digital variant detected:', v.title);
            return true;
          }
          break;
        }
      }
    }

    return false;
  }

  function interceptAddToCart(event) {
    console.log('[MealMems] interceptAddToCart called, event target:', event.target);
    var form = event.target;
    if (!form.matches || !form.matches('form[action="/cart/add"]')) {
      console.log('[MealMems] Not a cart form, ignoring');
      return;
    }

    console.log('[MealMems] Cart form submission detected, checking if digital...');

    // Check if this is a digital download - if so, don't intercept
    if (isDigitalSelection()) {
      console.log('[MealMems] Digital Download selected - allowing normal cart add');
      // Let the normal form submission proceed for digital downloads
      // Fileflare will handle the digital fulfillment
      return;
    }

    console.log('[MealMems] Print/Framed selected - intercepting form submission');
    event.preventDefault();
    event.stopPropagation();

    var options = getSelectedOptions();
    var printFileUrl = getPrintFileUrl(options.orientation);
    var displayImageUrl = getDisplayImageUrl(options.orientation);

    // Determine which Gelato template to use based on product type
    var gelatoVariantId;
    var productType;
    if (isFramedProduct()) {
      gelatoVariantId = getFramedPosterVariantId(options.size, options.orientation, options.frameColor);
      productType = 'Framed';
      console.log('[MealMems] Framed product - routing to Framed Poster variant:', gelatoVariantId);
    } else {
      gelatoVariantId = getFineArtPosterVariantId(options.size, options.orientation);
      productType = 'Poster';
      console.log('[MealMems] Poster product - routing to Fine Art Poster variant:', gelatoVariantId);
    }
    console.log('[MealMems] Using print file for orientation:', options.orientation);
    console.log('[MealMems] Using display image for orientation:', options.orientation);

    var formData = {
      id: gelatoVariantId,
      quantity: 1,
      properties: {
        // Visible properties (shown in checkout, emails, and Gelato)
        'Restaurant': productData.restaurantName,
        // Hidden properties (underscore prefix hides from cart display)
        '_mealmems_orientation': options.orientation,
        '_mealmems_size': options.size,
        '_mealmems_print_file': printFileUrl,
        '_mealmems_restaurant_name': productData.restaurantName,
        '_mealmems_restaurant_image': displayImageUrl,
        '_mealmems_place_id': productData.placeId || '',
        '_mealmems_original_product': productData.productHandle,
        '_mealmems_product_type': productType
      }
    };

    // Add frame color for framed products
    if (isFramedProduct()) {
      formData.properties['_mealmems_frame_color'] = options.frameColor;
      formData.properties['Frame'] = options.frameColor;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      return response.json();
    })
    .then(function(data) {
      console.log('[MealMems] Added to cart:', data);
      if (window.location.pathname.indexOf('/products/') !== -1) {
        window.location.href = '/cart';
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    })
    .catch(function(error) {
      console.error('[MealMems] Add to cart failed:', error);
      alert('Sorry, there was an error adding to cart. Please try again.');
    });
  }

  // Listen for native form submissions (legacy themes)
  document.addEventListener('submit', interceptAddToCart, true);

  /**
   * PRIMARY intercept: capture clicks on Add to Cart buttons before Dawn sees them.
   * Using stopImmediatePropagation() ensures Dawn's handlers never fire for print variants.
   */
  document.addEventListener('click', function(e) {
    // Find the closest submit button
    var btn = e.target && e.target.closest ? e.target.closest('[type="submit"]') : null;
    if (!btn) return;

    var form = btn.closest('form[action="/cart/add"]');
    if (!form) return;

    // Re-read productData in case it changed
    var currentProductData = window.mealmemesProductData;
    if (!currentProductData || !currentProductData.isRestaurantProduct) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    var selectedVariantId = parseInt(variantInput.value, 10);

    // Find the selected variant in our product data
    var selectedVariant = null;
    if (currentProductData.variants) {
      for (var i = 0; i < currentProductData.variants.length; i++) {
        if (currentProductData.variants[i].id === selectedVariantId) {
          selectedVariant = currentProductData.variants[i];
          break;
        }
      }
    }

    if (!selectedVariant) return; // Not one of our variants

    // Check if digital — let those proceed normally
    var isDigital = selectedVariant && (
      (selectedVariant.option1 && selectedVariant.option1.toLowerCase().indexOf('digital') !== -1) ||
      (selectedVariant.option2 && selectedVariant.option2.toLowerCase().indexOf('digital') !== -1) ||
      (selectedVariant.option3 && selectedVariant.option3.toLowerCase().indexOf('digital') !== -1) ||
      (selectedVariant.title && selectedVariant.title.toLowerCase().indexOf('digital') !== -1)
    );
    if (isDigital) {
      console.log('[MealMems] Digital variant — allowing normal add to cart');
      return;
    }

    // It's a print/framed variant — take over completely
    e.preventDefault();
    e.stopImmediatePropagation();

    console.log('[MealMems] Click intercepted — adding Gelato variant directly');

    var opts = getSelectedOptions();
    var printFileUrl = getPrintFileUrl(opts.orientation);
    var displayImageUrl = getDisplayImageUrl(opts.orientation);

    var gelatoVariantId;
    var productType;
    if (isFramedProduct()) {
      gelatoVariantId = getFramedPosterVariantId(opts.size, opts.orientation, opts.frameColor);
      productType = 'Framed';
    } else {
      gelatoVariantId = getFineArtPosterVariantId(opts.size, opts.orientation);
      productType = 'Poster';
    }

    console.log('[MealMems] Routing to Gelato variant:', gelatoVariantId, 'Size:', opts.size, 'Orientation:', opts.orientation);

    var formData = {
      id: gelatoVariantId,
      quantity: 1,
      properties: {
        'Restaurant': currentProductData.restaurantName,
        '_mealmems_orientation': opts.orientation,
        '_mealmems_size': opts.size,
        '_mealmems_print_file': printFileUrl,
        '_mealmems_restaurant_name': currentProductData.restaurantName,
        '_mealmems_restaurant_image': displayImageUrl,
        '_mealmems_place_id': currentProductData.placeId || '',
        '_mealmems_original_product': currentProductData.productHandle,
        '_mealmems_product_type': productType
      }
    };

    if (isFramedProduct()) {
      formData.properties['_mealmems_frame_color'] = opts.frameColor;
      formData.properties['Frame'] = opts.frameColor;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Cart add failed: ' + response.status);
      return response.json();
    })
    .then(function() {
      console.log('[MealMems] Successfully added Gelato variant to cart');
      window.location.href = '/cart';
    })
    .catch(function(err) {
      console.error('[MealMems] Add to cart failed:', err);
      alert('Sorry, there was an error adding to cart. Please try again.');
    });
  }, true); // capture phase — fires before any other handler

  var buyNowButtons = document.querySelectorAll('[data-buy-now], .shopify-payment-button button');
  for (var i = 0; i < buyNowButtons.length; i++) {
    buyNowButtons[i].addEventListener('click', function(event) {
      // Check if this is a digital download - if so, don't intercept
      if (isDigitalSelection()) {
        console.log('[MealMems] Digital Download selected - allowing normal buy now');
        // For digital, add to cart normally then redirect to checkout
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      var options = getSelectedOptions();
      var printFileUrl = getPrintFileUrl(options.orientation);
      var displayImageUrl = getDisplayImageUrl(options.orientation);

      // Determine which Gelato template to use
      var gelatoVariantId;
      var productType;
      if (isFramedProduct()) {
        gelatoVariantId = getFramedPosterVariantId(options.size, options.orientation, options.frameColor);
        productType = 'Framed';
      } else {
        gelatoVariantId = getFineArtPosterVariantId(options.size, options.orientation);
        productType = 'Poster';
      }

      var formData = {
        id: gelatoVariantId,
        quantity: 1,
        properties: {
          // Visible properties (shown in checkout, emails, and Gelato)
          'Restaurant': productData.restaurantName,
          // Hidden properties (underscore prefix hides from cart display)
          '_mealmems_orientation': options.orientation,
          '_mealmems_size': options.size,
          '_mealmems_print_file': printFileUrl,
          '_mealmems_restaurant_name': productData.restaurantName,
          '_mealmems_restaurant_image': displayImageUrl,
          '_mealmems_place_id': productData.placeId || '',
          '_mealmems_original_product': productData.productHandle,
          '_mealmems_product_type': productType
        }
      };

      // Add frame color for framed products
      if (isFramedProduct()) {
        formData.properties['_mealmems_frame_color'] = options.frameColor;
        formData.properties['Frame'] = options.frameColor;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(function(response) { return response.json(); })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function(error) {
        console.error('[MealMems] Buy now failed:', error);
        alert('Sorry, there was an error. Please try again.');
      });
    }, true);
  }

  console.log('[MealMems] Cart integration loaded for:', productData.restaurantName);

  /**
   * Format Option Visibility Toggle (Dawn Theme)
   *
   * When Format option exists (Print / Digital Download):
   * - Hide Size and Orientation options by default (only show Format)
   * - When Print is selected, show Size and Orientation
   * - When Digital Download is selected, keep Size/Orientation hidden
   *
   * Uses CSS classes + style injection for persistence against Dawn's re-renders
   */
  function setupFormatOptionToggle() {
    if (!productData.hasFormatOption) {
      console.log('[MealMems] No Format option - using legacy variant structure');
      return;
    }

    console.log('[MealMems] Setting up Format option toggle for Dawn theme');

    // Inject CSS for format toggle (this persists even when Dawn re-renders)
    if (!document.getElementById('mealmems-format-styles')) {
      var styleEl = document.createElement('style');
      styleEl.id = 'mealmems-format-styles';
      styleEl.textContent = `
        /* Hide Size and Orientation when Digital Download is selected */
        /* Target by data attributes we add */
        body.mealmems-digital-selected [data-mealmems-option="size"],
        body.mealmems-digital-selected [data-mealmems-option="orientation"] {
          display: none !important;
        }

        /* Also hide parent containers if they exist */
        body.mealmems-digital-selected [data-mealmems-option="size"],
        body.mealmems-digital-selected [data-mealmems-option="orientation"],
        body.mealmems-digital-selected .product-form__input:has([data-mealmems-option="size"]),
        body.mealmems-digital-selected .product-form__input:has([data-mealmems-option="orientation"]) {
          display: none !important;
        }

        /* Show digital info only when digital is selected */
        #mealmems-digital-info {
          display: none;
        }
        body.mealmems-digital-selected #mealmems-digital-info {
          display: block !important;
        }

        /* Digital info styling - matches theme */
        #mealmems-digital-info .mealmems-digital-box {
          border: 1px solid rgba(var(--color-foreground), 0.1);
          border-radius: 4px;
          padding: 1.5rem;
          margin: 1.5rem 0;
          background: rgba(var(--color-foreground), 0.03);
        }
        #mealmems-digital-info .mealmems-digital-title {
          font-family: var(--font-heading-family);
          font-size: 1.4rem;
          margin: 0 0 1rem 0;
          color: rgba(var(--color-foreground), 1);
        }
        #mealmems-digital-info ul {
          margin: 0;
          padding-left: 1.2rem;
          color: rgba(var(--color-foreground), 0.75);
          font-size: 1.3rem;
          line-height: 1.8;
        }
        #mealmems-digital-info li {
          margin-bottom: 0.3rem;
        }

        /* Show print info only when print is selected (not digital) */
        #mealmems-print-info {
          display: block;
        }
        body.mealmems-digital-selected #mealmems-print-info {
          display: none !important;
        }

        /* Print info styling - matches digital info */
        #mealmems-print-info .mealmems-print-box {
          border: 1px solid rgba(var(--color-foreground), 0.1);
          border-radius: 4px;
          padding: 1.5rem;
          margin: 1.5rem 0;
          background: rgba(var(--color-foreground), 0.03);
        }
        #mealmems-print-info .mealmems-print-text {
          margin: 0;
          color: rgba(var(--color-foreground), 0.75);
          font-size: 1.3rem;
          line-height: 1.6;
        }

        /* Delivery estimate styling */
        #mealmems-print-info .mealmems-delivery-estimate {
          margin-top: 1rem;
          padding-top: 1rem;
          border-top: 1px solid rgba(var(--color-foreground), 0.08);
        }
        #mealmems-print-info .mealmems-delivery-main {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin: 0;
          color: rgba(var(--color-foreground), 0.9);
          font-size: 1.3rem;
          font-weight: 500;
        }
        #mealmems-print-info .mealmems-delivery-detail {
          margin: 0.3rem 0 0 0;
          color: rgba(var(--color-foreground), 0.6);
          font-size: 1.1rem;
        }
        #mealmems-print-info .mealmems-delivery-loading {
          color: rgba(var(--color-foreground), 0.5);
          font-size: 1.2rem;
        }
      `;
      document.head.appendChild(styleEl);
    }

    // Function to find and mark fieldsets
    function markFieldsets() {
      // Find all potential option containers
      var containers = document.querySelectorAll('fieldset, .product-form__input, variant-radios > div, variant-selects > div');

      containers.forEach(function(container) {
        var legend = container.querySelector('legend, .form__label, label');
        if (!legend) return;

        var legendText = legend.textContent.toLowerCase().trim();

        if (legendText.indexOf('size') !== -1 && legendText.indexOf('format') === -1) {
          container.setAttribute('data-mealmems-option', 'size');
          // Also mark parent if it exists
          if (container.parentElement && container.parentElement.classList.contains('product-form__input')) {
            container.parentElement.setAttribute('data-mealmems-option', 'size');
          }
        } else if (legendText.indexOf('orientation') !== -1) {
          container.setAttribute('data-mealmems-option', 'orientation');
          // Also mark parent if it exists
          if (container.parentElement && container.parentElement.classList.contains('product-form__input')) {
            container.parentElement.setAttribute('data-mealmems-option', 'orientation');
          }
        } else if (legendText.indexOf('format') !== -1) {
          container.setAttribute('data-mealmems-option', 'format');
        }
      });

      // Also directly find elements by their legend/label text content
      document.querySelectorAll('legend, .form__label').forEach(function(label) {
        var text = label.textContent.toLowerCase().trim();
        var parent = label.closest('fieldset, .product-form__input');
        if (!parent) return;

        if (text === 'orientation') {
          parent.setAttribute('data-mealmems-option', 'orientation');
        } else if (text === 'size') {
          parent.setAttribute('data-mealmems-option', 'size');
        } else if (text === 'format') {
          parent.setAttribute('data-mealmems-option', 'format');
        }
      });
    }

    // Create digital download info element if it doesn't exist
    function ensureDigitalInfo() {
      if (document.getElementById('mealmems-digital-info')) {
        console.log('[MealMems] Digital info already exists');
        return;
      }

      var formatFieldset = document.querySelector('[data-mealmems-option="format"]');
      if (!formatFieldset) {
        console.log('[MealMems] Format fieldset not found, cannot add digital info');
        return;
      }

      var digitalInfo = document.createElement('div');
      digitalInfo.id = 'mealmems-digital-info';
      digitalInfo.innerHTML = '<div class="mealmems-digital-box">' +
        '<p class="mealmems-digital-title">Digital Download Includes</p>' +
        '<ul>' +
        '<li>High-resolution JPG file (8K quality)</li>' +
        '<li>Instant delivery via email after purchase</li>' +
        '<li>Unlimited personal use</li>' +
        '</ul></div>';

      formatFieldset.parentNode.insertBefore(digitalInfo, formatFieldset.nextSibling);
      console.log('[MealMems] Digital info element created');
    }

    // Create print info element if it doesn't exist
    function ensurePrintInfo() {
      if (document.getElementById('mealmems-print-info')) {
        return;
      }

      var formatFieldset = document.querySelector('[data-mealmems-option="format"]');
      if (!formatFieldset) {
        return;
      }

      var printInfo = document.createElement('div');
      printInfo.id = 'mealmems-print-info';
      printInfo.innerHTML = '<div class="mealmems-print-box">' +
        '<p class="mealmems-print-text">Printed on premium fine art paper with archival inks for lasting quality.</p>' +
        '<div class="mealmems-delivery-estimate" id="mealmems-delivery-estimate">' +
        '<p class="mealmems-delivery-loading">Checking delivery times...</p>' +
        '</div>' +
        '</div>';

      formatFieldset.parentNode.insertBefore(printInfo, formatFieldset.nextSibling);
      console.log('[MealMems] Print info element created');

      // Fetch delivery estimate after creating the element
      fetchDeliveryEstimate();
    }

    /**
     * Fetch and display delivery estimate based on user's location
     */
    function fetchDeliveryEstimate() {
      var estimateContainer = document.getElementById('mealmems-delivery-estimate');
      if (!estimateContainer) return;

      // Check localStorage cache first (1 hour TTL)
      var cacheKey = 'mealmems_delivery_estimate';
      var cached = localStorage.getItem(cacheKey);
      if (cached) {
        try {
          var cachedData = JSON.parse(cached);
          var cacheAge = Date.now() - cachedData.timestamp;
          if (cacheAge < 3600000) { // 1 hour
            displayDeliveryEstimate(cachedData.estimate);
            return;
          }
        } catch (e) {
          // Invalid cache, fetch fresh
        }
      }

      // Fetch from API
      fetch(MEALMEMS_API_BASE_URL + '/api/shipping/estimate')
        .then(function(response) {
          if (!response.ok) throw new Error('Failed to fetch estimate');
          return response.json();
        })
        .then(function(data) {
          if (data.success && data.estimate) {
            // Cache the result
            localStorage.setItem(cacheKey, JSON.stringify({
              timestamp: Date.now(),
              estimate: data.estimate
            }));
            displayDeliveryEstimate(data.estimate);
          }
        })
        .catch(function(error) {
          console.log('[MealMems] Delivery estimate fetch failed:', error);
          // Show a default estimate on error
          displayDeliveryEstimate({
            displayText: '5-18 business days',
            detailText: 'Production + shipping'
          });
        });
    }

    /**
     * Display the delivery estimate in the UI
     */
    function displayDeliveryEstimate(estimate) {
      var estimateContainer = document.getElementById('mealmems-delivery-estimate');
      if (!estimateContainer) return;

      estimateContainer.innerHTML =
        '<p class="mealmems-delivery-main">' +
        '<span>Estimated delivery: ' + estimate.displayText + '</span>' +
        '</p>' +
        '<p class="mealmems-delivery-detail">' + estimate.detailText + '</p>';

      console.log('[MealMems] Delivery estimate displayed:', estimate.displayText);
    }

    // Track last state to reduce console spam
    var lastIsDigital = null;

    // Function to update body class based on Format
    function updateFormatClass() {
      var isDigital = isDigitalSelection();

      // Only log and update when state changes
      if (isDigital !== lastIsDigital) {
        console.log('[MealMems] Format state changed - isDigital:', isDigital);
        lastIsDigital = isDigital;

        if (isDigital) {
          document.body.classList.add('mealmems-digital-selected');
        } else {
          document.body.classList.remove('mealmems-digital-selected');
        }
      }
    }

    // Initial setup
    markFieldsets();
    ensureDigitalInfo();
    ensurePrintInfo();
    updateFormatClass();

    // Debounce function to prevent excessive updates
    var updateTimeout = null;
    function debouncedUpdate() {
      if (updateTimeout) return;
      updateTimeout = setTimeout(function() {
        updateTimeout = null;
        markFieldsets();
        ensureDigitalInfo();
        ensurePrintInfo();
        updateFormatClass();
      }, 100);
    }

    // Listen for clicks anywhere in the product form area (catches variant changes)
    var productFormArea = document.querySelector('.product-form, .product, form[action="/cart/add"]');
    if (productFormArea) {
      productFormArea.addEventListener('click', function() {
        // Delay to let Dawn update the DOM first
        setTimeout(debouncedUpdate, 50);
      });
      productFormArea.addEventListener('change', debouncedUpdate);
    }

    // Also observe the URL for variant changes (Dawn updates URL when variant changes)
    var lastUrl = window.location.href;
    setInterval(function() {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        debouncedUpdate();
      }
    }, 200);

    console.log('[MealMems] Format option toggle enabled');
  }

  // Initialize Format toggle after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(setupFormatOptionToggle, 200);
    });
  } else {
    // Delay to ensure Dawn theme has initialized
    setTimeout(setupFormatOptionToggle, 200);
  }

})();
